import _ from "lodash";

class User {
  constructor(userJson) {
    _.assign(this, userJson)
  }

  can(action, resource) {
    return _(this.scopes)
      .map(scope => _(scope).split(".").thru(([ resource, action ]) => ({ resource, action })).value())
      .find(({ action: scopeAction, resource: scopeResource }) => action === scopeAction && _.includes(scopeResource, resource));
  }

  canCancel({ type }) {
    return this.can("cancel", type);
  }

  canRepeat({ type }) {
    return this.can("repeat", type);
  }

  canPrescribe() {
    return this.can("create", "prescriptions") || this.can("create", "orders");
  }
}

class DoctorUser extends User {
  landingRoute() {
    return "/";
  }
  getArticle() {
    return this.title === "Dr" ? "El" : "La";
  }

  getPreposition() {
    return this.title === "Dr" ? "del" : "de la";
  }

  fullNameWithTitle() {
    return `${this.title}. ${this.name} ${this.surname}`
  }

  patientsDisplayNames() {
    return {
      title: `${this.getArticle()} ${this.fullNameWithTitle()}`,
      preposition: `${this.getPreposition()} ${this.fullNameWithTitle()}`,
    };
  }
}

class AssistantUser extends User {
  //TODO rename prescriptions => medical-documents
  landingRoute() {
    return "/prescriptions";
  }
  patientsDisplayNames() {
    const healthCenterName = this.myHealthCenter.name;
    return {
      title: `El centro ${healthCenterName}`,
      preposition: `del centro ${healthCenterName}`,
    }
  }
}

export const toReifiedUser = userJson => {
  const UserTypeMap = {
    doctor: DoctorUser,
    assistant: AssistantUser
  };

  const UserType = _.get(UserTypeMap, userJson.type)
  if (!UserType) throw new Error("invalid user type");

  return new UserType(userJson);
};